// This file was automatically generated. ** Do Not Edit **
// To update this file, run:
//   npm run generate-segment-event-fields

export const segmentEventRequiredFields = {
  "acceptOrderModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "acceptedOrderMapFilterSelected": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "selected_categories",
    "store_is_open",
    "uf"
  ],
  "acceptedOrderMapPinClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "order_id",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "acceptedOrderMapPinDetailsClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "order_id",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "acceptedOrderMapPinModalViewed": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_id",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "acceptedOrderMapPinModalViewedProduct": [
    "base_price",
    "brand",
    "deal_id",
    "is_returnable",
    "price",
    "promotion_type",
    "quantity"
  ],
  "acceptedOrderMapViewed": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "order_ids",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "selected_categories",
    "store_is_open",
    "uf"
  ],
  "accountInfoPageViewed": [
    "screen_name"
  ],
  "accountRecoveryViewed": [
    "modal_name",
    "screen_name"
  ],
  "activateIntegratorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "allFiltersModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "announceStoreModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "assistedOperationalModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "bankAccountInfoClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "bankInfoConfirmationModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "calendarModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "changeStatusErrorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "checkoutWithoutCodeModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "checkoutWithoutCodeModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "closeStoreModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "codeFAQModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "codeFAQModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "confirmCancelOrderModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "confirmCancellationOrderFirstPurchaseModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "confirmDeliveryModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "confirmEditModalClicked": [
    "cart_value",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "customer_preference",
    "device_id",
    "initial_cart_value",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "confirmEditModalClickedProductsEdit": [
    "is_deleted",
    "original_product_name",
    "original_quantity",
    "substitute_product_name",
    "substitute_quantity"
  ],
  "confirmPickupClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "confirmPickupClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "confirmPickupModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "confirmPickupModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "confirmPickupModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "confirmRejectOrderFirstPurchaseModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "confirmRejectOrderModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "confirmReplacementModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "confirmReplacementModalClickedProductsEdit": [
    "is_deleted",
    "original_product_name",
    "original_quantity",
    "substitute_product_name",
    "substitute_quantity"
  ],
  "confirmationEditModalViewed": [
    "city",
    "component_category",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "confirmationEditModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "confirmationEditModalViewedProductsEdit": [
    "is_deleted",
    "original_product_name",
    "original_quantity",
    "substitute_product_name",
    "substitute_quantity"
  ],
  "datesAvailabilityModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "datesAvailabilityViewed": [
    "modal_name",
    "screen_name"
  ],
  "deactivateIntegratorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "deactivatedCampaignAlertModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "deleteProductModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "quantity_of_products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "deleteProductModalClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "delivererApprovalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "deliverymanApprovalFeedbackModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "deliverymanApprovalModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "deliverymanApprovalViewed": [
    "modal_name",
    "screen_name"
  ],
  "deliverymanManagerViewed": [
    "modal_name",
    "screen_name"
  ],
  "discountAvailabilityViewed": [
    "city",
    "coordinates",
    "device_id",
    "discount_info",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "discountInfo": [
    "is_available",
    "product_id",
    "product_name"
  ],
  "discountClicked": [
    "campaign_name",
    "campaign_products",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "discount_campaign_is_on",
    "discount_is_on",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "product_id",
    "screen_name",
    "store_discount_percent",
    "store_is_open",
    "uf",
    "ze_discount_percent"
  ],
  "discountClickedCampaignProduct": [
    "availability_product_variant_id",
    "days_active",
    "discount",
    "periods_active",
    "product_variant_id"
  ],
  "discountModalClicked": [
    "campaign_name",
    "campaign_products",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "discount_campaign_is_on",
    "discount_modal_info",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "product_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "discountModalClickedCampaignProduct": [
    "availability_product_variant_id",
    "days_active",
    "discount",
    "periods_active",
    "product_variant_id"
  ],
  "discountModalInfo": [
    "days_active",
    "discount_is_scheduled",
    "periods_active",
    "scheduling_is_active",
    "suggested_percent"
  ],
  "distributorMapModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "dynamicRadiusFAQModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "dynamicRadiusModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "dynamicRadiusScreenViewed": [
    "component_category",
    "component_name",
    "modal_name",
    "previous_screen_name",
    "screen_name"
  ],
  "dynamicRadiusViewed": [
    "modal_name",
    "screen_name"
  ],
  "editHistoryModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "editOrderModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "editPOCInfoViewed": [
    "modal_name",
    "screen_name"
  ],
  "explanationLastTransferModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "featureDiscoveryMarkupModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "financialReportViewed": [
    "modal_name",
    "screen_name"
  ],
  "financialReportsActionClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "financialReportsHighlightedQuestionsClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_week",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "financialReportsPageViewed": [
    "end_date",
    "refund",
    "refund_coupon",
    "refund_incentive",
    "refund_markup",
    "refund_shipping",
    "start_date",
    "total_sold"
  ],
  "fleetManagementViewed": [
    "modal_name",
    "screen_name"
  ],
  "guideTourClicked": [
    "component_category",
    "component_name",
    "modal_name",
    "poc_id",
    "screen_name",
    "step_badge",
    "step_current",
    "step_route",
    "step_title",
    "step_total",
    "target_id",
    "tour_action",
    "tour_campaign_id",
    "tour_current",
    "tour_id",
    "tour_route",
    "tour_total",
    "tour_type",
    "tour_version"
  ],
  "guideTourViewed": [
    "modal_name",
    "poc_id",
    "screen_name",
    "step_badge",
    "step_current",
    "step_route",
    "step_title",
    "step_total",
    "target_id",
    "tour_campaign_id",
    "tour_current",
    "tour_id",
    "tour_route",
    "tour_total",
    "tour_type",
    "tour_version"
  ],
  "headerActionClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "homeActionClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "homePageViewed": [
    "modal_name",
    "screen_name"
  ],
  "inSeparationOrderModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "insertMainPhoneModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "inventoryModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "dispute_info",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "product_id",
    "screen_name",
    "seller_product_code",
    "store_is_open",
    "uf"
  ],
  "disputeInfo": [
    "amount_paid",
    "dispute_type",
    "more_info",
    "suggested_weight"
  ],
  "listsRecommendationModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "loginError": [
    "error_type",
    "poc_id",
    "screen_name"
  ],
  "loginErrorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "loginModalViewed": [
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name"
  ],
  "loginPageClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "is_clicked_checkbox",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "uf"
  ],
  "loginSucceeded": [
    "poc_id",
    "screen_name",
    "success_type"
  ],
  "loginViewed": [
    "modal_name",
    "screen_name"
  ],
  "mFAClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "uf"
  ],
  "maintenanceViewed": [
    "modal_name",
    "screen_name"
  ],
  "managementViewed": [
    "modal_name",
    "screen_name"
  ],
  "manualExperimentConversionConfirmed": [
    "experiment_name",
    "owner",
    "screen_name",
    "variant_name"
  ],
  "manualExperimentTriggered": [
    "experiment_name",
    "owner",
    "screen_name",
    "variant_id",
    "variant_name"
  ],
  "mapPackingOrderClicked": [
    "app_instance",
    "component_category",
    "component_name",
    "experiment_name",
    "previous_screen_name",
    "screen_name",
    "variant_id",
    "variant_name"
  ],
  "mapPinClicked": [
    "app_instance",
    "component_category",
    "component_name",
    "pin_type",
    "screen_name"
  ],
  "marketplaceInventoryModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "menuActionClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "minimumPortfolioRefreshed": [
    "group_name",
    "refresh_type"
  ],
  "modalReimbursementInfoModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "moreOptionsClicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "product_category",
    "product_id",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "myAccountClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "integration_is_enabled",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "selected_tab_name",
    "store_is_open",
    "uf"
  ],
  "myAccountModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "screen_name",
    "selected_tab_name",
    "store_is_open",
    "uf"
  ],
  "myAccountModalViewed": [
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open"
  ],
  "myAccountViewed": [
    "modal_name",
    "screen_name"
  ],
  "myFleetViewed": [
    "modal_name",
    "screen_name"
  ],
  "newOrderCardClicked": [
    "app_instance",
    "component_category",
    "component_name",
    "screen_name"
  ],
  "newOrderModalClicked": [
    "app_instance",
    "component_category",
    "component_name",
    "modal_name",
    "screen_name"
  ],
  "newOrderModalViewed": [
    "macro_journey",
    "micro_journey",
    "modal_name",
    "previous_component",
    "previous_component_name",
    "screen_name"
  ],
  "newPasswordModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "newStoreAdded": [
    "properties"
  ],
  "newStoreCanceled": [
    "properties"
  ],
  "noDeliverymanLinkedViewed": [
    "modal_name",
    "screen_name"
  ],
  "noPhoneWarningModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "notFoundErrorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "offerEditModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "onAppRating": [
    "properties"
  ],
  "onGoingOrderModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "onSaleProductsViewed": [
    "modal_name",
    "screen_name"
  ],
  "ongoingOrderListSorted": [
    "order_list_type",
    "sort_by"
  ],
  "onlinePaymentActionClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "onlinePaymentFiltersSelected": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "online_payment_filter_info",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "onlinePaymentFilterInfo": [
    "order_date",
    "payment_type",
    "search_term",
    "status",
    "transaction_date"
  ],
  "onlinePaymentViewed": [
    "modal_name",
    "screen_name"
  ],
  "onlinePaymentWelcomeModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "openStoreModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "orderAccepted": [
    "delivery_fee",
    "discount",
    "order_date",
    "order_id",
    "payment_method",
    "products",
    "quantity_of_products",
    "subtotal",
    "tax"
  ],
  "orderAcceptedProduct": [
    "base_price",
    "brand",
    "deal_id",
    "is_returnable",
    "price",
    "promotion_type",
    "quantity"
  ],
  "orderAcceptedClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderAlreadyEditedModalViewed": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderCanceled": [
    "delivery_fee",
    "discount",
    "order_date",
    "order_id",
    "order_status",
    "payment_method",
    "products",
    "quantity_of_products",
    "reason",
    "subtotal",
    "tax"
  ],
  "orderCanceledProduct": [
    "base_price",
    "brand",
    "deal_id",
    "is_returnable",
    "price",
    "promotion_type",
    "quantity"
  ],
  "orderCardClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "orderDetailModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "orderDetailViewed": [
    "modal_name",
    "screen_name"
  ],
  "orderDetailsPrint": [
    "order_id",
    "order_status"
  ],
  "orderDetailsViewed": [
    "coupon_description",
    "coupon_discount",
    "coupon_title",
    "delivery_fee",
    "discount",
    "first_order_tag",
    "invoice_requested",
    "order_date",
    "order_id",
    "order_status",
    "payment_method",
    "previous_screen_name",
    "products",
    "quantity_of_products",
    "returnable_quantity",
    "subtotal",
    "tax",
    "total"
  ],
  "orderDetailsViewedProduct": [
    "base_price",
    "brand",
    "deal_id",
    "is_returnable",
    "price",
    "promotion_type",
    "quantity"
  ],
  "orderEditClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "orderEditHistoryClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderEditModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "customer_preference",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderEditModalClickedProductsEdit": [
    "is_deleted",
    "original_product_name",
    "original_quantity",
    "substitute_product_name",
    "substitute_quantity"
  ],
  "orderEditModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "orderEditModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderEditValueLimitErrorViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "edit_value_limit_type",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderHistoryFilterCancelClicked": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderHistoryFilterClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "order_list_types",
    "order_status_list",
    "payment_methods_list",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "ranked_status_list",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderHistoryFilterRemoveAllClicked": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderHistoryFilterRemoveClicked": [
    "city",
    "coordinates",
    "device_id",
    "filter_key",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderHistoryItemClicked": [
    "city",
    "client_name",
    "coordinates",
    "delivery_person_email",
    "device_id",
    "itens_per_page",
    "macro_journey",
    "micro_journey",
    "order_amount",
    "order_date_time",
    "order_id",
    "order_status",
    "order_type",
    "page_number",
    "payment_method",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "ranked_status",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderHistoryViewed": [
    "city",
    "coordinates",
    "device_id",
    "itens_per_page",
    "macro_journey",
    "micro_journey",
    "page_number",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "returned_itens_count",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderInformationDetailsClicked": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderInformationDetailsClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderInformationModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "total",
    "uf"
  ],
  "orderInformationModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderListViewed": [
    "end_date",
    "filter_orders_list",
    "orders",
    "page",
    "page_size",
    "previous_screen_name",
    "searched_text",
    "start_date"
  ],
  "filterOrdersList": [
    "filter_orders_list"
  ],
  "order": [
    "is_returnable",
    "order_date",
    "order_id",
    "order_rating",
    "order_status",
    "payment_method",
    "total"
  ],
  "orderMapViewed": [
    "order_id",
    "order_status"
  ],
  "orderModalPendingAcceptedAllClicked": [
    "city",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "pending_orders_flag",
    "pending_orders_no_flag",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderPendingAcceptedAllClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "pending_orders",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderRejected": [
    "delivery_fee",
    "discount",
    "order_date",
    "order_id",
    "order_status",
    "payment_method",
    "products",
    "quantity_of_products",
    "reason",
    "subtotal",
    "tax"
  ],
  "orderRejectedProduct": [
    "base_price",
    "brand",
    "deal_id",
    "is_returnable",
    "price",
    "promotion_type",
    "quantity"
  ],
  "orderRejectedClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusCancelOrderClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusCancelOrderClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusDetailsViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "discount",
    "items_list",
    "macro_journey",
    "micro_journey",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "previous_status",
    "screen_name",
    "service_fee_description",
    "service_fee_value",
    "shipping",
    "store_is_open",
    "subtotal",
    "total",
    "uf"
  ],
  "orderStatusDetailsViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusHistoryModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "orderStatusModalPhoneCloseClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusModalPhoneCloseClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusModalPhoneConfirmClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "reason_selected",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusModalPhoneConfirmClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusModalRejectCloseClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusModalRejectCloseClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusModalRejectConfirmClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "reason_selected",
    "screen_name",
    "store_is_open",
    "uf",
    "unavailable_products"
  ],
  "orderStatusModalRejectConfirmClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusPrintClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusPrintClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusShowMapClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusShowMapClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderStatusShowPhoneClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "orderStatusShowPhoneClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "orderUndoEditModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "ordersDetailsModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "ordersMapViewed": [
    "modal_name",
    "screen_name"
  ],
  "outOfStockModalClicked": [
    "app_instance",
    "changes_count",
    "component_category",
    "component_name",
    "has_changes",
    "screen_name"
  ],
  "outOfStockModalViewed": [
    "macro_journey",
    "micro_journey",
    "modal_name",
    "previous_component",
    "previous_component_name",
    "screen_name"
  ],
  "pOCOrdersScheduledViewed": [
    "modal_name",
    "screen_name"
  ],
  "pOCOrdersViewed": [
    "modal_name",
    "screen_name"
  ],
  "partnerBankDetailsViewed": [
    "modal_name",
    "screen_name"
  ],
  "passwordResetCognitoModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "paymentRegisterClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "last_status",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "paymentRegisterModalViewed": [
    "city",
    "component_category",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "performanceClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "selected_tab_name",
    "store_is_open",
    "uf"
  ],
  "performancePageViewed": [
    "accuracy",
    "accuracy_achiv",
    "availability_rate",
    "availability_rate_goal",
    "delivered_in_35_min",
    "delivered_in_35_min_goal",
    "end_date",
    "fulfillment_rate",
    "fulfillment_rate_target",
    "ideal_portifolio_goal",
    "ideal_portifolio_percentage",
    "rating",
    "rating_goal",
    "ready_in_10_min",
    "ready_in_10_min_goal",
    "start_date",
    "total_orders"
  ],
  "performanceViewed": [
    "modal_name",
    "screen_name"
  ],
  "phoneUnavailableModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "phoneValidationModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "phoneVerificationCodeSent": [
    "screen_name"
  ],
  "phoneVerificationConfirmed": [
    "screen_name"
  ],
  "phoneVerificationFailed": [
    "screen_name",
    "verification_failure_reason"
  ],
  "planExplanationModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "portfolioProductsFilters": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_selection",
    "filter_type",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "product_search",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "prepareProductsModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "productAvailabilityToggleSelected": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "delivery_type",
    "device_id",
    "macro_journey",
    "micro_journey",
    "origin_name",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "section",
    "store_is_open",
    "uf"
  ],
  "productAvailabilityUpdated": [
    "base_price",
    "category",
    "inventory_tab",
    "is_available",
    "is_minimum_portfolio",
    "product_name",
    "sku"
  ],
  "productCodeClicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "productCodeInfoModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "productCodeModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "productDisputeClicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "productInventoryViewed": [
    "filter_product_inventory",
    "ideal_portifolio_percentage",
    "inventory_tab",
    "page",
    "page_size",
    "product_inventory",
    "searched_text"
  ],
  "filterProductInventory": [
    "filter_product_inventory"
  ],
  "productInventory": [
    "base_price",
    "category",
    "image_url",
    "is_available",
    "is_minimum_portfolio",
    "is_returnable",
    "product_name"
  ],
  "productPortfolioViewed": [
    "modal_name",
    "screen_name"
  ],
  "productReplacementModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "product_replaced_name",
    "quantity_of_products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "productReplacementModalClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "productsFavorited": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "fav_button",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "productsOnSaleModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "promotionInterestModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "promotionScheduleModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "qRCodeModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "queryErrorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "recoverPasswordFormModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "recoverPasswordSuccessModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "refundReportExported": [
    "end_date",
    "refund",
    "refund_coupon",
    "refund_incentive",
    "refund_markup",
    "refund_shipping",
    "start_date"
  ],
  "registrationCanceled": [
    "screen_name"
  ],
  "registrationFailed": [
    "failure_reason",
    "screen_name"
  ],
  "registrationSummaryModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "reimbursementClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "reimbursementReportsModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "report_category",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "reimbursementReportsModalViewed": [
    "city",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "reimbursementViewed": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "page_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "reimbursementWeekViewed": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "page_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "removeDeliverymanModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "removeStoreAnnouncementModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "remunerationPlanModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "remunerationPlanModalViewed": [
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open"
  ],
  "reportProductModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "reselectCourierClicked": [
    "app_instance",
    "component_category",
    "component_name",
    "experiment_name",
    "previous_screen_name",
    "screen_name",
    "variant_id",
    "variant_name"
  ],
  "resetEditModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "resetEditModalClickedProductsEdit": [
    "is_deleted",
    "original_product_name",
    "original_quantity",
    "substitute_product_name",
    "substitute_quantity"
  ],
  "resetQuantityModalClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "quantity_of_products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "revertToOriginalOrderClicked": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "revertToOriginalOrderClickedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "scheduledOrdersModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "searchedProductsViewed": [
    "modal_name",
    "screen_name"
  ],
  "sellerContractModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "sendMessageToClientModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "shortcutInventoryModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "signUpChangePhoneModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "signUpConfirmationModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "signUpFormViewed": [
    "modal_name",
    "screen_name"
  ],
  "signUpLandingPageViewed": [
    "modal_name",
    "screen_name"
  ],
  "signUpSuccessViewed": [
    "modal_name",
    "screen_name"
  ],
  "storeClosingDialogModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "storeStatusChanged": [
    "city",
    "coordinates",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "storeStatusUpdated": [
    "screen_name",
    "status_store"
  ],
  "storeSwitched": [
    "properties"
  ],
  "suggestionEditModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "suggestionEditModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "supportContactChannelSelected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "supportContactChannelsViewed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "supportFeatureSelected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "supportHubCalled": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "supportHubError": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "supportHubViewed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "switchStorePageViewed": [
    "accounts_quantity",
    "redirection_method"
  ],
  "tenMinutesDeliveryReleaseRateViewed": [
    "modal_name",
    "screen_name"
  ],
  "termsAndConditionsViewed": [
    "screen_name"
  ],
  "termsErrorModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "ticketCategoryLoadingFailed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketCategorySelected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketCategorySelectionCompleted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketCategorySelectionFailed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketCategorySelectionStarted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketFieldFilled": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketFieldSelectionFailed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketRequestStarted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketStepCompleted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubcategoryLoadingFailed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubcategorySelected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubcategorySelectionCompleted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubcategorySelectionFailed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubcategorySelectionStarted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubmissionCompleted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubmissionFailed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "ticketSubmitted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "totalSoldReportExported": [
    "end_date",
    "start_date",
    "total_sold"
  ],
  "transactionDetailsModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "unavailableProductModalViewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "unavailableProductModalViewedItemsList": [
    "base_price",
    "name",
    "price",
    "product_id",
    "quantity"
  ],
  "verificationCodeClicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "uf"
  ],
  "viewPhoneModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "whatsappModalViewed": [
    "modal_name",
    "screen_name"
  ],
  "youTubeVideoModalViewed": [
    "modal_name",
    "screen_name"
  ]
} as const

export const segmentTrackEventRequiredFields = {
  "Accepted Order Map Filter Selected": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "selected_categories",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Pin Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "order_id",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Pin Details Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "order_id",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Pin Modal Viewed": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_id",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Viewed": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "order_ids",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "selected_categories",
    "store_is_open",
    "uf"
  ],
  "Account Info Page Viewed": [
    "screen_name"
  ],
  "Account Recovery Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Activate Integrator Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "All Filters Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Announce Store Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Assisted Operational Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Bank Account Info Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Bank Info Confirmation Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Calendar Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Change Status Error Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Checkout Without Code Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Close Store Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Code Faq Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Confirm Cancel Order Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Confirm Cancellation Order First Purchase Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Confirm Delivery Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Confirm Edit Modal Clicked": [
    "cart_value",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "customer_preference",
    "device_id",
    "initial_cart_value",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Confirm Pickup Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Confirm Pickup Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Confirm Pickup Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Confirm Reject Order First Purchase Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Confirm Reject Order Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Confirm Replacement Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Confirmation Edit Modal Viewed": [
    "city",
    "component_category",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Dates Availability Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Dates Availability Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Deactivate Integrator Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Deactivated Campaign Alert Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Delete Product Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "quantity_of_products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Deliverer Approval Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Deliveryman Approval Feedback Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Deliveryman Approval Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Deliveryman Approval Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Deliveryman Manager Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Discount Availability Viewed": [
    "city",
    "coordinates",
    "device_id",
    "discount_info",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Discount Clicked": [
    "campaign_name",
    "campaign_products",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "discount_campaign_is_on",
    "discount_is_on",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "product_id",
    "screen_name",
    "store_discount_percent",
    "store_is_open",
    "uf",
    "ze_discount_percent"
  ],
  "Discount Modal Clicked": [
    "campaign_name",
    "campaign_products",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "discount_campaign_is_on",
    "discount_modal_info",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "product_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Distributor Map Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Dynamic Radius FAQ Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Dynamic Radius Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Dynamic Radius Screen Viewed": [
    "component_category",
    "component_name",
    "modal_name",
    "previous_screen_name",
    "screen_name"
  ],
  "Dynamic Radius Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Edit History Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Edit Order Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Edit POC Info Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Explanation Last Transfer Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Feature Discovery Markup Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Financial Report Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Financial Reports Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Financial Reports Highlighted Questions Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_week",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Financial Reports Page Viewed": [
    "end_date",
    "refund",
    "refund_coupon",
    "refund_incentive",
    "refund_markup",
    "refund_shipping",
    "start_date",
    "total_sold"
  ],
  "Fleet Management Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Guide Tour Clicked": [
    "component_category",
    "component_name",
    "modal_name",
    "poc_id",
    "screen_name",
    "step_badge",
    "step_current",
    "step_route",
    "step_title",
    "step_total",
    "target_id",
    "tour_action",
    "tour_campaign_id",
    "tour_current",
    "tour_id",
    "tour_route",
    "tour_total",
    "tour_type",
    "tour_version"
  ],
  "Guide Tour Viewed": [
    "modal_name",
    "poc_id",
    "screen_name",
    "step_badge",
    "step_current",
    "step_route",
    "step_title",
    "step_total",
    "target_id",
    "tour_campaign_id",
    "tour_current",
    "tour_id",
    "tour_route",
    "tour_total",
    "tour_type",
    "tour_version"
  ],
  "Header Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Home Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Home Page Viewed": [
    "modal_name",
    "screen_name"
  ],
  "In Separation Order Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Insert Main Phone Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Inventory Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "dispute_info",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "product_id",
    "screen_name",
    "seller_product_code",
    "store_is_open",
    "uf"
  ],
  "Lists Recommendation Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Login Error": [
    "error_type",
    "poc_id",
    "screen_name"
  ],
  "Login Error Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Login Modal Viewed": [
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name"
  ],
  "Login Page Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "is_clicked_checkbox",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "uf"
  ],
  "Login Succeeded": [
    "poc_id",
    "screen_name",
    "success_type"
  ],
  "Login Viewed": [
    "modal_name",
    "screen_name"
  ],
  "MFA Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "uf"
  ],
  "Maintenance Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Management Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Manual Experiment Conversion Confirmed": [
    "experiment_name",
    "owner",
    "screen_name",
    "variant_name"
  ],
  "Manual Experiment Triggered": [
    "experiment_name",
    "owner",
    "screen_name",
    "variant_id",
    "variant_name"
  ],
  "Map Packing Order Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "experiment_name",
    "previous_screen_name",
    "screen_name",
    "variant_id",
    "variant_name"
  ],
  "Map Pin Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "pin_type",
    "screen_name"
  ],
  "Marketplace Inventory Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Menu Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Minimum Portfolio Refreshed": [
    "group_name",
    "refresh_type"
  ],
  "Modal Reimbursement Info Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "More Options Clicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "product_category",
    "product_id",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "My Account Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "integration_is_enabled",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "selected_tab_name",
    "store_is_open",
    "uf"
  ],
  "My Account Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "screen_name",
    "selected_tab_name",
    "store_is_open",
    "uf"
  ],
  "My Account Modal Viewed": [
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open"
  ],
  "My Account Viewed": [
    "modal_name",
    "screen_name"
  ],
  "My Fleet Viewed": [
    "modal_name",
    "screen_name"
  ],
  "New Order Card Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "screen_name"
  ],
  "New Order Modal Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "modal_name",
    "screen_name"
  ],
  "New Order Modal Viewed": [
    "macro_journey",
    "micro_journey",
    "modal_name",
    "previous_component",
    "previous_component_name",
    "screen_name"
  ],
  "New Password Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "New Store Added": [
    "properties"
  ],
  "New Store Canceled": [
    "properties"
  ],
  "No Deliveryman Linked Viewed": [
    "modal_name",
    "screen_name"
  ],
  "No Phone Warning Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Not Found Error Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Offer Edit Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "On App Rating": [
    "properties"
  ],
  "On Going Order Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "On Sale Products Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Ongoing Order List Sorted": [
    "order_list_type",
    "sort_by"
  ],
  "Online Payment Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Online Payment Filters Selected": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "online_payment_filter_info",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Online Payment Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Online Payment Welcome Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Open Store Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Order Accepted": [
    "delivery_fee",
    "discount",
    "order_date",
    "order_id",
    "payment_method",
    "products",
    "quantity_of_products",
    "subtotal",
    "tax"
  ],
  "Order Accepted Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Already Edited Modal Viewed": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Canceled": [
    "delivery_fee",
    "discount",
    "order_date",
    "order_id",
    "order_status",
    "payment_method",
    "products",
    "quantity_of_products",
    "reason",
    "subtotal",
    "tax"
  ],
  "Order Card Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Order Detail Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Order Detail Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Order Details Print": [
    "order_id",
    "order_status"
  ],
  "Order Details Viewed": [
    "coupon_description",
    "coupon_discount",
    "coupon_title",
    "delivery_fee",
    "discount",
    "first_order_tag",
    "invoice_requested",
    "order_date",
    "order_id",
    "order_status",
    "payment_method",
    "previous_screen_name",
    "products",
    "quantity_of_products",
    "returnable_quantity",
    "subtotal",
    "tax",
    "total"
  ],
  "Order Edit Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Order Edit History Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Edit Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "customer_preference",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Edit Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Order Edit Value Limit Error Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "edit_value_limit_type",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Cancel Clicked": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "order_list_types",
    "order_status_list",
    "payment_methods_list",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "ranked_status_list",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Remove All Clicked": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Remove Clicked": [
    "city",
    "coordinates",
    "device_id",
    "filter_key",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order History Item Clicked": [
    "city",
    "client_name",
    "coordinates",
    "delivery_person_email",
    "device_id",
    "itens_per_page",
    "macro_journey",
    "micro_journey",
    "order_amount",
    "order_date_time",
    "order_id",
    "order_status",
    "order_type",
    "page_number",
    "payment_method",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "ranked_status",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order History Viewed": [
    "city",
    "coordinates",
    "device_id",
    "itens_per_page",
    "macro_journey",
    "micro_journey",
    "page_number",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "returned_itens_count",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Information Details Clicked": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Information Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "order_status",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "total",
    "uf"
  ],
  "Order List Viewed": [
    "end_date",
    "filter_orders_list",
    "orders",
    "page",
    "page_size",
    "previous_screen_name",
    "searched_text",
    "start_date"
  ],
  "Order Map Viewed": [
    "order_id",
    "order_status"
  ],
  "Order Modal Pending Accepted All Clicked": [
    "city",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "pending_orders_flag",
    "pending_orders_no_flag",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Pending Accepted All Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "pending_orders",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Rejected": [
    "delivery_fee",
    "discount",
    "order_date",
    "order_id",
    "order_status",
    "payment_method",
    "products",
    "quantity_of_products",
    "reason",
    "subtotal",
    "tax"
  ],
  "Order Rejected Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Cancel Order Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Details Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "discount",
    "items_list",
    "macro_journey",
    "micro_journey",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "previous_status",
    "screen_name",
    "service_fee_description",
    "service_fee_value",
    "shipping",
    "store_is_open",
    "subtotal",
    "total",
    "uf"
  ],
  "Order Status History Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Order Status Modal Phone Close Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Modal Phone Confirm Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "reason_selected",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Modal Reject Close Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Modal Reject Confirm Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "reason_selected",
    "screen_name",
    "store_is_open",
    "uf",
    "unavailable_products"
  ],
  "Order Status Print Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Show Map Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Status Show Phone Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "micro_journey",
    "order_number",
    "order_status",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Order Undo Edit Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Orders Details Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Orders Map Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Out Of Stock Modal Clicked": [
    "app_instance",
    "changes_count",
    "component_category",
    "component_name",
    "has_changes",
    "screen_name"
  ],
  "Out Of Stock Modal Viewed": [
    "macro_journey",
    "micro_journey",
    "modal_name",
    "previous_component",
    "previous_component_name",
    "screen_name"
  ],
  "POC Orders Scheduled Viewed": [
    "modal_name",
    "screen_name"
  ],
  "POC Orders Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Partner Bank Details Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Password Reset Cognito Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Payment Register Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "last_status",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Payment Register Modal Viewed": [
    "city",
    "component_category",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Performance Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_value",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "selected_tab_name",
    "store_is_open",
    "uf"
  ],
  "Performance Page Viewed": [
    "accuracy",
    "accuracy_achiv",
    "availability_rate",
    "availability_rate_goal",
    "delivered_in_35_min",
    "delivered_in_35_min_goal",
    "end_date",
    "fulfillment_rate",
    "fulfillment_rate_target",
    "ideal_portifolio_goal",
    "ideal_portifolio_percentage",
    "rating",
    "rating_goal",
    "ready_in_10_min",
    "ready_in_10_min_goal",
    "start_date",
    "total_orders"
  ],
  "Performance Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Phone Unavailable Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Phone Validation Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Phone Verification Code Sent": [
    "screen_name"
  ],
  "Phone Verification Confirmed": [
    "screen_name"
  ],
  "Phone Verification Failed": [
    "screen_name",
    "verification_failure_reason"
  ],
  "Plan Explanation Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Portfolio Products Filters": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_selection",
    "filter_type",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "product_search",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Prepare Products Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Product Availability Toggle Selected": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "delivery_type",
    "device_id",
    "macro_journey",
    "micro_journey",
    "origin_name",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "section",
    "store_is_open",
    "uf"
  ],
  "Product Availability Updated": [
    "base_price",
    "category",
    "inventory_tab",
    "is_available",
    "is_minimum_portfolio",
    "product_name",
    "sku"
  ],
  "Product Code Clicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Product Code Info Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Product Code Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Product Dispute Clicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Product Inventory Viewed": [
    "filter_product_inventory",
    "ideal_portifolio_percentage",
    "inventory_tab",
    "page",
    "page_size",
    "product_inventory",
    "searched_text"
  ],
  "Product Portfolio Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Product Replacement Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "product_replaced_name",
    "quantity_of_products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Products Favorited": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "fav_button",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Products On Sale Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Promotion Interest Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Promotion Schedule Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "QR Code Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Query Error Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Recover Password Form Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Recover Password Success Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Refund Report Exported": [
    "end_date",
    "refund",
    "refund_coupon",
    "refund_incentive",
    "refund_markup",
    "refund_shipping",
    "start_date"
  ],
  "Registration Canceled": [
    "screen_name"
  ],
  "Registration Failed": [
    "failure_reason",
    "screen_name"
  ],
  "Registration Summary Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Reimbursement Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Reimbursement Reports Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "report_category",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Reimbursement Reports Modal Viewed": [
    "city",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Reimbursement Viewed": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "page_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Reimbursement Week Viewed": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "page_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Remove Deliveryman Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Remove Store Announcement Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Remuneration Plan Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "modal_name",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Remuneration Plan Modal Viewed": [
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open"
  ],
  "Report Product Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Reselect Courier Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "experiment_name",
    "previous_screen_name",
    "screen_name",
    "variant_id",
    "variant_name"
  ],
  "Reset Edit Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Reset Quantity Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "modal_name",
    "order_number",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "quantity_of_products",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Revert To Original Order Clicked": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Scheduled Orders Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Searched Products Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Seller Contract Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Send Message To Client Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Shortcut Inventory Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Sign Up Change Phone Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Sign Up Confirmation Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Sign Up Form Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Sign Up Landing Page Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Sign Up Success Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Store Closing Dialog Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Store Status Changed": [
    "city",
    "coordinates",
    "poc_id",
    "screen_name",
    "store_is_open",
    "uf"
  ],
  "Store Status Updated": [
    "screen_name",
    "status_store"
  ],
  "Store Switched": [
    "properties"
  ],
  "Suggestion Edit Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Support Contact Channel Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Contact Channels Viewed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Feature Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Hub Called": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Hub Error": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Hub Viewed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Switch Store Page Viewed": [
    "accounts_quantity",
    "redirection_method"
  ],
  "Ten Minutes Delivery Release Rate Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Terms And Conditions Viewed": [
    "screen_name"
  ],
  "Terms Error Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Ticket Category Loading Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selection Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selection Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selection Started": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Field Filled": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Field Selection Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Request Started": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Step Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Loading Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selection Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selection Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selection Started": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Submission Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Submission Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Submitted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "poc_id",
    "screen_name",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Total Sold Report Exported": [
    "end_date",
    "start_date",
    "total_sold"
  ],
  "Transaction Details Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Unavailable Product Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "modal_name",
    "order_number",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Verification Code Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "poc_id",
    "screen_name",
    "uf"
  ],
  "View Phone Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "Whatsapp Modal Viewed": [
    "modal_name",
    "screen_name"
  ],
  "YouTube Video Modal Viewed": [
    "modal_name",
    "screen_name"
  ]
} as const

export const segmentTrackEventAllowedFields = {
  "Accepted Order Map Filter Selected": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "selected_categories",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Pin Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_id",
    "owner_squad",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Pin Details Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_id",
    "owner_squad",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Pin Modal Viewed": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_id",
    "owner_squad",
    "pin_color",
    "pin_color_description",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "products",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Accepted Order Map Viewed": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_ids",
    "owner_squad",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "selected_categories",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Account Info Page Viewed": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Account Recovery Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Activate Integrator Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "All Filters Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Announce Store Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Assisted Operational Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Bank Account Info Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Bank Info Confirmation Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Calendar Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Change Status Error Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Checkout Without Code Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Close Store Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Code Faq Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Confirm Cancel Order Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Confirm Cancellation Order First Purchase Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Confirm Delivery Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Confirm Edit Modal Clicked": [
    "cart_value",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "customer_preference",
    "device_id",
    "initial_cart_value",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "products_edit",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Confirm Pickup Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Confirm Pickup Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Confirm Pickup Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Confirm Reject Order First Purchase Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Confirm Reject Order Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Confirm Replacement Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Confirmation Edit Modal Viewed": [
    "city",
    "component_category",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Dates Availability Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Dates Availability Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Deactivate Integrator Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Deactivated Campaign Alert Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Delete Product Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "quantity_of_products",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Deliverer Approval Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Deliveryman Approval Feedback Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Deliveryman Approval Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Deliveryman Approval Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Deliveryman Manager Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Discount Availability Viewed": [
    "city",
    "coordinates",
    "device_id",
    "discount_info",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Discount Clicked": [
    "campaign_name",
    "campaign_products",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "discount_campaign_is_on",
    "discount_is_on",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_id",
    "screen_name",
    "session_id",
    "store_discount_percent",
    "store_is_open",
    "uf",
    "ze_discount_percent"
  ],
  "Discount Modal Clicked": [
    "campaign_name",
    "campaign_products",
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "discount_campaign_is_on",
    "discount_modal_info",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_id",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Distributor Map Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Dynamic Radius FAQ Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Dynamic Radius Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Dynamic Radius Screen Viewed": [
    "component_category",
    "component_name",
    "modal_name",
    "owner_squad",
    "previous_screen_name",
    "screen_name",
    "session_id"
  ],
  "Dynamic Radius Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Edit History Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Edit Order Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Edit POC Info Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Explanation Last Transfer Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Feature Discovery Markup Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Financial Report Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Financial Reports Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "filter_value",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Financial Reports Highlighted Questions Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_week",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Financial Reports Page Viewed": [
    "end_date",
    "media_source",
    "owner_squad",
    "refund",
    "refund_coupon",
    "refund_incentive",
    "refund_markup",
    "refund_shipping",
    "session_id",
    "start_date",
    "total_sold"
  ],
  "Fleet Management Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Guide Tour Clicked": [
    "component_category",
    "component_name",
    "modal_name",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "step_badge",
    "step_current",
    "step_route",
    "step_title",
    "step_total",
    "target_id",
    "tour_action",
    "tour_campaign_id",
    "tour_current",
    "tour_id",
    "tour_route",
    "tour_total",
    "tour_type",
    "tour_version"
  ],
  "Guide Tour Viewed": [
    "modal_name",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "step_badge",
    "step_current",
    "step_route",
    "step_title",
    "step_total",
    "target_id",
    "tour_campaign_id",
    "tour_current",
    "tour_id",
    "tour_route",
    "tour_total",
    "tour_type",
    "tour_version"
  ],
  "Header Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Home Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Home Page Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "In Separation Order Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Insert Main Phone Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Inventory Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "dispute_info",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "poc_id",
    "product_id",
    "screen_name",
    "seller_product_code",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Lists Recommendation Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Login Error": [
    "error_type",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id"
  ],
  "Login Error Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Login Modal Viewed": [
    "modal_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id"
  ],
  "Login Page Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "is_clicked_checkbox",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "uf"
  ],
  "Login Succeeded": [
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "success_type"
  ],
  "Login Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "MFA Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "uf"
  ],
  "Maintenance Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Management Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Manual Experiment Conversion Confirmed": [
    "experiment_name",
    "media_source",
    "owner",
    "owner_squad",
    "screen_name",
    "session_id",
    "variant_name"
  ],
  "Manual Experiment Triggered": [
    "experiment_end_date",
    "experiment_name",
    "media_source",
    "owner",
    "owner_squad",
    "screen_name",
    "session_id",
    "variant_id",
    "variant_name"
  ],
  "Map Packing Order Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "experiment_name",
    "media_source",
    "owner_squad",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "variant_id",
    "variant_name"
  ],
  "Map Pin Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "media_source",
    "owner_squad",
    "pin_type",
    "screen_name",
    "session_id"
  ],
  "Marketplace Inventory Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Menu Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Minimum Portfolio Refreshed": [
    "group_name",
    "media_source",
    "owner_squad",
    "refresh_type",
    "session_id"
  ],
  "Modal Reimbursement Info Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "More Options Clicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_category",
    "product_id",
    "scheduled_availability",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "My Account Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "integration_is_enabled",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "selected_tab_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "My Account Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "poc_id",
    "screen_name",
    "selected_tab_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "My Account Modal Viewed": [
    "modal_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open"
  ],
  "My Account Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "My Fleet Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "New Order Card Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "New Order Modal Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "media_source",
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "New Order Modal Viewed": [
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "previous_component",
    "previous_component_name",
    "screen_name",
    "session_id"
  ],
  "New Password Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "New Store Added": [
    "media_source",
    "owner_squad",
    "session_id",
    "properties"
  ],
  "New Store Canceled": [
    "media_source",
    "owner_squad",
    "session_id",
    "properties"
  ],
  "No Deliveryman Linked Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "No Phone Warning Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Not Found Error Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Offer Edit Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "On App Rating": [
    "media_source",
    "owner_squad",
    "session_id",
    "properties"
  ],
  "On Going Order Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "On Sale Products Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Ongoing Order List Sorted": [
    "media_source",
    "order_list_type",
    "owner_squad",
    "session_id",
    "sort_by"
  ],
  "Online Payment Action Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Online Payment Filters Selected": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "online_payment_filter_info",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Online Payment Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Online Payment Welcome Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Open Store Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Order Accepted": [
    "delivery_fee",
    "discount",
    "media_source",
    "order_date",
    "order_id",
    "owner_squad",
    "payment_method",
    "products",
    "quantity_of_products",
    "session_id",
    "subtotal",
    "tax"
  ],
  "Order Accepted Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Already Edited Modal Viewed": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Canceled": [
    "delivery_fee",
    "discount",
    "media_source",
    "order_date",
    "order_id",
    "order_status",
    "owner_squad",
    "payment_method",
    "products",
    "quantity_of_products",
    "reason",
    "session_id",
    "subtotal",
    "tax"
  ],
  "Order Card Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Order Detail Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Order Detail Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Order Details Print": [
    "media_source",
    "order_id",
    "order_status",
    "owner_squad",
    "session_id"
  ],
  "Order Details Viewed": [
    "coupon_description",
    "coupon_discount",
    "coupon_title",
    "delivery_fee",
    "discount",
    "first_order_tag",
    "invoice_requested",
    "media_source",
    "order_date",
    "order_id",
    "order_status",
    "owner_squad",
    "payment_method",
    "previous_screen_name",
    "products",
    "quantity_of_products",
    "returnable_quantity",
    "session_id",
    "subtotal",
    "tax",
    "total"
  ],
  "Order Edit Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Order Edit History Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Edit Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "customer_preference",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Edit Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Order Edit Value Limit Error Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "edit_value_limit_type",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Cancel Clicked": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "filter_value",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_list_types",
    "order_status_list",
    "owner_squad",
    "payment_methods_list",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "ranked_status_list",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Remove All Clicked": [
    "city",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order History Filter Remove Clicked": [
    "city",
    "coordinates",
    "device_id",
    "filter_key",
    "filter_value",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order History Item Clicked": [
    "city",
    "client_name",
    "coordinates",
    "delivery_person_email",
    "device_id",
    "itens_per_page",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_amount",
    "order_date_time",
    "order_id",
    "order_status",
    "order_type",
    "owner_squad",
    "page_number",
    "payment_method",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "ranked_status",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order History Viewed": [
    "city",
    "coordinates",
    "device_id",
    "itens_per_page",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "page_number",
    "poc_id",
    "previous_component_name",
    "previous_screen_name",
    "returned_itens_count",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Information Details Clicked": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Information Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "total",
    "uf"
  ],
  "Order List Viewed": [
    "end_date",
    "filter_orders_list",
    "media_source",
    "orders",
    "owner_squad",
    "page",
    "page_size",
    "previous_screen_name",
    "searched_text",
    "session_id",
    "start_date"
  ],
  "Order Map Viewed": [
    "media_source",
    "order_id",
    "order_status",
    "owner_squad",
    "session_id"
  ],
  "Order Modal Pending Accepted All Clicked": [
    "city",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "modal_name",
    "owner_squad",
    "pending_orders_flag",
    "pending_orders_no_flag",
    "poc_id",
    "previous_screen_name",
    "print_option",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Pending Accepted All Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "owner_squad",
    "pending_orders",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Rejected": [
    "delivery_fee",
    "discount",
    "media_source",
    "order_date",
    "order_id",
    "order_status",
    "owner_squad",
    "payment_method",
    "products",
    "quantity_of_products",
    "reason",
    "session_id",
    "subtotal",
    "tax"
  ],
  "Order Rejected Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Cancel Order Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Details Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "discount",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "previous_status",
    "screen_name",
    "service_fee_description",
    "service_fee_value",
    "session_id",
    "shipping",
    "store_is_open",
    "subtotal",
    "total",
    "uf"
  ],
  "Order Status History Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Order Status Modal Phone Close Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Modal Phone Confirm Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "reason_selected",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Modal Reject Close Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Modal Reject Confirm Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "reason_selected",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf",
    "unavailable_products"
  ],
  "Order Status Print Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Show Map Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Status Show Phone Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "macro_journey",
    "media_source",
    "micro_journey",
    "order_number",
    "order_status",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Order Undo Edit Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Orders Details Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Orders Map Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Out Of Stock Modal Clicked": [
    "app_instance",
    "changes_count",
    "component_category",
    "component_name",
    "has_changes",
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Out Of Stock Modal Viewed": [
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "previous_component",
    "previous_component_name",
    "screen_name",
    "session_id"
  ],
  "POC Orders Scheduled Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "POC Orders Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Partner Bank Details Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Password Reset Cognito Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Payment Register Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "last_status",
    "media_source",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Payment Register Modal Viewed": [
    "city",
    "component_category",
    "coordinates",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Performance Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_value",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "selected_tab_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Performance Page Viewed": [
    "accuracy",
    "accuracy_achiv",
    "availability_rate",
    "availability_rate_goal",
    "delivered_in_35_min",
    "delivered_in_35_min_goal",
    "end_date",
    "fulfillment_rate",
    "fulfillment_rate_target",
    "ideal_portifolio_goal",
    "ideal_portifolio_percentage",
    "media_source",
    "owner_squad",
    "rating",
    "rating_goal",
    "ready_in_10_min",
    "ready_in_10_min_goal",
    "session_id",
    "start_date",
    "total_orders"
  ],
  "Performance Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Phone Unavailable Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Phone Validation Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Phone Verification Code Sent": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Phone Verification Confirmed": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Phone Verification Failed": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id",
    "verification_failure_reason"
  ],
  "Plan Explanation Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Portfolio Products Filters": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_selection",
    "filter_type",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_search",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Prepare Products Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Product Availability Toggle Selected": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "delivery_type",
    "device_id",
    "macro_journey",
    "micro_journey",
    "origin_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "section",
    "store_is_open",
    "uf"
  ],
  "Product Availability Updated": [
    "base_price",
    "category",
    "inventory_tab",
    "is_available",
    "is_minimum_portfolio",
    "media_source",
    "owner_squad",
    "product_name",
    "session_id",
    "sku"
  ],
  "Product Code Clicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Product Code Info Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Product Code Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Product Dispute Clicked": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Product Inventory Viewed": [
    "filter_product_inventory",
    "ideal_portifolio_percentage",
    "inventory_tab",
    "media_source",
    "owner_squad",
    "page",
    "page_size",
    "product_inventory",
    "searched_text",
    "session_id"
  ],
  "Product Portfolio Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Product Replacement Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "product_replaced_name",
    "quantity_of_products",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Products Favorited": [
    "city",
    "common_availability",
    "component_category",
    "coordinates",
    "device_id",
    "fav_button",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "price_discount_common",
    "price_discount_scheduled",
    "price_pdv_common",
    "price_pdv_scheduled",
    "price_ttc_common",
    "price_ttc_scheduled",
    "product_category",
    "product_id",
    "product_name",
    "scheduled_availability",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Products On Sale Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Promotion Interest Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Promotion Schedule Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "QR Code Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Query Error Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Recover Password Form Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Recover Password Success Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Refund Report Exported": [
    "end_date",
    "media_source",
    "owner_squad",
    "refund",
    "refund_coupon",
    "refund_incentive",
    "refund_markup",
    "refund_shipping",
    "session_id",
    "start_date"
  ],
  "Registration Canceled": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Registration Failed": [
    "failure_reason",
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Registration Summary Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Reimbursement Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Reimbursement Reports Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "media_source",
    "modal_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "report_category",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Reimbursement Reports Modal Viewed": [
    "city",
    "coordinates",
    "device_id",
    "filter_datetime_end",
    "filter_datetime_initial",
    "media_source",
    "modal_name",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Reimbursement Viewed": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "page_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Reimbursement Week Viewed": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "page_number",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf",
    "week_year_reference"
  ],
  "Remove Deliveryman Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Remove Store Announcement Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Remuneration Plan Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "modal_name",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Remuneration Plan Modal Viewed": [
    "modal_name",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open"
  ],
  "Report Product Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Reselect Courier Clicked": [
    "app_instance",
    "component_category",
    "component_name",
    "experiment_name",
    "media_source",
    "owner_squad",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "variant_id",
    "variant_name"
  ],
  "Reset Edit Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "products_edit",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Reset Quantity Modal Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "poc_id",
    "previous_screen_name",
    "product_name",
    "quantity_of_products",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Revert To Original Order Clicked": [
    "city",
    "component_name",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Scheduled Orders Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Searched Products Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Seller Contract Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Send Message To Client Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Shortcut Inventory Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Sign Up Change Phone Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Sign Up Confirmation Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Sign Up Form Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Sign Up Landing Page Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Sign Up Success Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Store Closing Dialog Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Store Status Changed": [
    "city",
    "coordinates",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "store_is_open",
    "uf"
  ],
  "Store Status Updated": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id",
    "status_store"
  ],
  "Store Switched": [
    "media_source",
    "owner_squad",
    "session_id",
    "properties"
  ],
  "Suggestion Edit Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Support Contact Channel Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Contact Channels Viewed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Feature Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Hub Called": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Hub Error": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Support Hub Viewed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Switch Store Page Viewed": [
    "accounts_quantity",
    "media_source",
    "owner_squad",
    "redirection_method",
    "session_id"
  ],
  "Ten Minutes Delivery Release Rate Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Terms And Conditions Viewed": [
    "media_source",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Terms Error Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Ticket Category Loading Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selection Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selection Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Category Selection Started": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Field Filled": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Field Selection Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Request Started": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Step Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Loading Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selected": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selection Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selection Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Subcategory Selection Started": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Submission Completed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Submission Failed": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Ticket Submitted": [
    "app_instance",
    "empty_mandatory_ticket_fields",
    "entry_method",
    "has_attachments",
    "has_empty_mandatory_ticket_fields",
    "media_source",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "support_category_english",
    "support_category_native",
    "support_sub_category_english",
    "support_sub_category_native",
    "ticket_description_free_text",
    "ticket_fields",
    "vendor_id"
  ],
  "Total Sold Report Exported": [
    "end_date",
    "media_source",
    "owner_squad",
    "session_id",
    "start_date",
    "total_sold"
  ],
  "Transaction Details Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Unavailable Product Modal Viewed": [
    "city",
    "coordinates",
    "delivery_type",
    "device_id",
    "items_list",
    "media_source",
    "modal_name",
    "order_number",
    "owner_squad",
    "payment_method",
    "poc_id",
    "previous_screen_name",
    "screen_name",
    "session_id",
    "sku_quantity",
    "store_is_open",
    "uf"
  ],
  "Verification Code Clicked": [
    "city",
    "component_category",
    "component_name",
    "coordinates",
    "device_id",
    "macro_journey",
    "media_source",
    "micro_journey",
    "owner_squad",
    "poc_id",
    "screen_name",
    "session_id",
    "uf"
  ],
  "View Phone Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "Whatsapp Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ],
  "YouTube Video Modal Viewed": [
    "modal_name",
    "owner_squad",
    "screen_name",
    "session_id"
  ]
} as const

export type SegmentEventName = keyof typeof segmentEventRequiredFields
export type SegmentTrackEventName = keyof typeof segmentTrackEventRequiredFields
